<template>
    <section class="topper topper-tall relative px-4">

        <div class="interior max-w-6xl mx-auto w-full relative z-20">
            <div class="grid">
                <div class="title-container flex items-end">
                    <Title class="w-full" :class="`tick-${tick}`"></Title>
                </div>
                <span class="sr-only">Big Problems, Little Problems</span>
                <div class="hero-container relative">
                    <img class="hero w-full" src="/wp-content/themes/landslide/img/hero.png" alt="Illustration of a man in business attire hugging his young son">
                </div>
                <div class="arrow-container flex justify-center" :class="`tick-${tick}`">
                    <Arrow></Arrow>
                </div>
            </div>

            <div :class="`tick-${tick}`" class="credits absolute z-30 text-sm text-right font-body text-gray-900">
                Written by <strong>Ben Feller</strong><br>
                Illustrated by <strong>Mercè López</strong><br>
                <span class="uppercase">Tilbury House Publishers</span>
            </div>

        </div>

        <SocialLinks color="text-secondary-500"></SocialLinks>

        <div class="backdrop absolute w-full">
            <img src="/wp-content/themes/landslide/img/hero-backdrop.png" aria-hidden="true">
        </div>

    </section>
</template>

<script>

// https://vueuse.org/core/useelementvisibility/#demo
import { ref, computed, onMounted } from 'vue';
import Title from './Utilities/Title.vue';
import Arrow from './Utilities/Arrow.vue';
import SocialLinks from './Utilities/SocialLinks.vue';

export default {
    
    props: ['data'],

    setup(props) {

        const tick = ref(0);
        onMounted(() => {
            let loop = window.setInterval(() => {
                tick.value = tick.value + 1;
                if (tick.value >= 5) {
                    window.clearInterval(loop);
                }
            }, 200);
        });

        return {
            tick,
            ...props.data
        }

    },

    components: {
        Arrow,
        Title,
        SocialLinks
    }

}
</script>